import { render } from "./SprintsView.vue?vue&type=template&id=c89fb89a&scoped=true"
import script from "./SprintsView.vue?vue&type=script&lang=js"
export * from "./SprintsView.vue?vue&type=script&lang=js"

import "./SprintsView.vue?vue&type=style&index=0&id=c89fb89a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89fb89a"]])

export default __exports__